export const API_BASE_URL = "/proxy.php";
// export const API_BASE_URL = "https://miles.sbaerp.com/sba/api";
// export const API_BASE_URL = "https://machakos.sbaerp.com/sba/api";

export const getTenantSubdomain = () => {
  const hostname = window.location.hostname;

  const parts = hostname.split(".");

  if (hostname === "localhost" || parts.length < 3) {
    return "miles";
  }

  return parts[0].toLowerCase();
};

// export const getApiBaseUrl = () => {
//   const tenant = getTenantSubdomain();

//   return `https://${tenant}.myapi.com/sba/api`;

// };
